import { ChevronRight } from "lucide-react";
import React from "react";
import { cn } from "@/lib/utils";
import type { BreadcrumbSeparatorProps } from "../types";

function BreadcrumbSeparator({
  className,
  children,
  ...props
}: BreadcrumbSeparatorProps) {
  return (
    <li
      data-slot="breadcrumb-separator"
      role="presentation"
      aria-hidden="true"
      className={cn("[&>svg]:size-3.5", className)}
      {...props}
    >
      {children ?? <ChevronRight />}
    </li>
  );
}

BreadcrumbSeparator.displayName = "Breadcrumb.Separator";

export default BreadcrumbSeparator;
